import { Component, OnInit } from "@angular/core";
import { ChartService } from "@app/services/chart.service";
import * as chartDefinitions from "@services/chartList.json";
import { Actions } from "@app/store/snowflake/reducer";
import { Store } from "@ngrx/store";
import { featureState } from "@app/store/user/reducer";
import { BaseComponent } from "@app/components/base.component";
import { selectStatistcsData } from "@app/store/snowflake/selector";
import { skip } from "rxjs/operators";
import { Statistics } from "@app/store/snowflake/state";
import { UDFApiService } from "@app/services/udf-api.service";
import { Observable } from "rxjs";
@Component({
    selector: "app-homefour-banner",
    templateUrl: "./homefour-banner.component.html",
    styleUrls: ["./homefour-banner.component.scss"],
})
export class HomefourBannerComponent extends BaseComponent implements OnInit {
    error: Boolean = false;
    errorText: String = "";
    data: Statistics;
    loading: boolean;
    chartData: Observable<any>;
    top5CategoriesByVolumeChart: any;
    top5SitesUsingUDFChart: any;
    top5OrgsUsingUDFChart: any;
    averageQueryTimeChart: any;
    queryByBUUsingUDFChart: any;
    top5CategoriesByVolume: any[] = [];

    top5SitesUsingUDF: any[] = [];
    top5OrgsUsingUDF: any[] = [];
    avgQueryTime: any[] = [];
    QueryByBUUsingUDF: any[] = [];

    bannerWrapperContent: Content[] = [
        {
            eyebrowText: "ExxonMobil",
            title: "Upstream Data Foundation",
            paragraphText:
                "A collection of cloud-based data technology, modern architecture, data applications, organizational capabilities, and data governance that will drive value for ExxonMobil.",
            defaultBtnIcon: "flaticon-right",
            defaultBtnText: "About Us",
            defaultBtnLink: "about-us",
            optionalBtnIcon: "flaticon-tick",
            optionalBtnText: "Get Started",
            optionalBtnLink: "contact",
        },
    ];

    chartNoteContent: NoteContent[] = [
        {
            title: "Note",
            note: [
                "This reflects curation work (manipulating ingested data prior to business user consumption) and user queries",
                "Kepler data only, additional platforms coming soon...",
            ],
        },
    ];
    statData = (chartDefinitions as any).default;

    constructor(
        private store: Store<{ snowflakeState: featureState }>,
        private chartService: ChartService,
        private udfApiSvc: UDFApiService,
    ) {
        super();
    }

    ngOnInit(): void {
        // this.store.select(selectStatistcsData).subscribe(data=>{
        //   this.data = data;
        // })

        this.store.dispatch(Actions.getStatistics());
        this.subscribeToStore(
            this.store.select(selectStatistcsData).pipe(skip(1)),
            (stats) => {
                if (stats && Object.keys(stats).length > 0) {
                    this.data = stats;
                    this.error = false;
                    //this.loading = false;
                    this.populateCharts(this.data);
                } else {
                    this.error = true;
                    this.errorText =
                        "There is an error while loading the charts";
                }
            },
        );

        // this.subscribeToStore(this.udfApiSvc.getStatistics(), (data) => {
        //   console.log("******************************** :",data)
        //   const stats = data;
        //   if (stats && Object.keys(stats).length > 0) {
        // 		this.data = stats;
        //     console.log("data from API: ", this.data)
        // 		this.loading = false;
        //   }
        // }
        // );

        // this.populateCharts(this.data)
        // this.subscribeToStore(this.udfApiSvc.getStatistics(), (data) => {
        //   //console.log("API call: ",data)
        //   this.data = data
        //   this.populateCharts(this.data)
        // });

        // this.store.dispatch(getStatistics())
    }

    populateCharts(data) {
        setTimeout(() => {
            // this.top5CategoriesByVolumeChart = this.chartService.populateTop5CategoriesByVolumeChart(this.top5CategoriesByVolume.map(val => ({ x: val.data, y: val.value })), this.top5CategoriesByVolumeChart);
            this.top5CategoriesByVolumeChart =
                this.chartService.populateTop5CategoriesByVolumeChart(
                    data.domainQueries.map((val) => ({
                        x: val.QUERIES,
                        y: val.L2_DOMAIN,
                    })),
                    this.top5CategoriesByVolumeChart,
                );
            this.top5SitesUsingUDFChart =
                this.chartService.populatetop5SitesUsingUDFChart(
                    data.trendingSites.map((val) => ({
                        x: val.ASSET,
                        y: val.QUERIES,
                    })),
                    this.top5SitesUsingUDFChart,
                );
            this.top5OrgsUsingUDFChart =
                this.chartService.populatetop5OrgsUsingUDFChart(
                    data.sitesQueries,
                    this.top5OrgsUsingUDFChart,
                );
            // this.averageQueryTimeChart = this.chartService.populateAverageQueryTimeChart(this.avgQueryTime.map(val => ({ x: val.date, y: val.value })), this.averageQueryTimeChart);
            this.queryByBUUsingUDFChart =
                this.chartService.populateQueryByBUUsingUDFChart(
                    data.businessUnitsQueries,
                    this.queryByBUUsingUDFChart,
                );
            // this.queryByBUUsingUDFChart = this.chartService.populateQueryByBUUsingUDFChart(data.businessUnitsQueries.map(val => ({ x: val.BUSINESS_UNITS, y: val.QUERIES })), this.queryByBUUsingUDFChart);
            100;
        });
    }
}
class Content {
    eyebrowText: string;
    title: string;
    paragraphText: string;
    defaultBtnIcon: string;
    defaultBtnText: string;
    defaultBtnLink: string;
    optionalBtnIcon: string;
    optionalBtnText: string;
    optionalBtnLink: string;
}

class NoteContent {
    title: string;
    note: string[];
}
